var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Doc / Invoice") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Doc-/-Invoice",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "File-List-3-Line",
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9999999,22.0000002 L4.99999987,22.0000002 L4.99999987,22.0000002 C3.34314987,22.0000002 1.99999987,20.65685 1.99999987,19.0000002 C1.99999987,19.0000002 1.99999987,19.0000002 1.99999987,19.0000002 L1.99999987,3.00000015 L1.99999987,3.00000015 C1.99999987,2.44771515 2.44771487,2.00000015 2.99999987,2.00000015 L16.9999999,2.00000015 L16.9999999,2.00000015 C17.5522848,2.00000015 17.9999999,2.44771515 17.9999999,3.00000015 L17.9999999,15.0000002 L21.9999999,15.0000002 L21.9999999,19.0000002 L21.9999999,19.0000002 C21.9999999,20.6568502 20.6568498,22.0000002 18.9999999,22.0000002 L18.9999999,22.0000002 Z M18,17 L18,19 L18,19 C18,19.5522852 18.447715,20 19,20 C19.552285,20 20,19.5522852 20,19 L20,17 L18,17 L18,17 Z M16,20 L16,4 L4,4 L4,19 L4,19 C4,19.5522852 4.447715,20 5,20 L16,20 L16,20 Z M6,7 L14,7 L14,9 L6,9 L6,7 Z M6,11 L14,11 L14,13 L6,13 L6,11 Z M6,15 L11,15 L11,17 L6,17 L6,15 Z",
    id: "Shape",
    fillOpacity: 0.64,
    fill: "#191923",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/Invoice.ecc36cc0d1c8fac79889841ef1f8791a.svg";
export { ForwardRef as ReactComponent };